import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "bg-white rounded p-5 print-pt-0"
}
const _hoisted_3 = {
  class: "pdf-item",
  style: {"break-inside":"avoid"}
}
const _hoisted_4 = { class: "mt-5" }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SurveryPlusStructureStep = _resolveComponent("SurveryPlusStructureStep")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex align-items-center justify-content-between z-index-1\"><div class=\"d-flex align-items-center\"><img src=\"/media/logos/plus_logo.png\" alt=\"\" class=\"h-50px w-auto me-5\"><h1 class=\"mt-3\">INCLUSION PLUS</h1></div><img src=\"/media/logos/bottom_logo.png\" alt=\"\" class=\"h-50px w-auto me-5\"></div>", 1)),
    (!_ctx.surveyPlusQuestionsLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surveyPlusStepList, (step) => {
            return (_openBlock(), _createElementBlock("section", {
              slot: "pdf-content",
              class: "survey-plus-structure",
              key: step.id
            }, [
              _createElementVNode("section", _hoisted_3, [
                _createElementVNode("h1", _hoisted_4, _toDisplayString(step.id) + ". " + _toDisplayString(step.attributes[_ctx.translateKey("description")]), 1),
                (step.id == 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "text-gray-600 fw-bold fs-6 mt-5",
                      innerHTML: _ctx.$t('SURVEY_PLUS_1_MESSAGE_INTRODUCTION')
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getQuestionByStep(step.id), (question) => {
                return (_openBlock(), _createElementBlock("section", {
                  class: "pdf-item",
                  key: question.id,
                  style: {"break-inside":"avoid"}
                }, [
                  _createVNode(_component_SurveryPlusStructureStep, {
                    question: question,
                    "is-summary": _ctx.isSummary
                  }, null, 8, ["question", "is-summary"])
                ]))
              }), 128))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}